module.exports = __webpack_public_path__ + "static/media/CC20-AP070-12-FAICO.f078b142.pdf";